<template>
  <swiper v-if="hasBannerList" ref="mySwiper" :class="$style.swiper" :options="swiperOption">
    <swiper-slide
      v-for="item in bannerList"
      :key="item.id"
      :class="$style['swiper-slide']"
      :style="{ backgroundImage: `url(${item.banner})` }"
    >
      <div :class="$style['banner-bottom']">
        <img :src="item.icon" alt />
        <div :class="$style['banner-info']">
          <div :class="$style['info-title']">{{ item.title }}</div>
          <div :class="$style['info-description']">{{ item.description }}</div>
        </div>
        <img :src="downloadImg" alt />
      </div>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
let _this = '';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import { getBannerList } from '@/api/app.js';
import { CDN_URL } from '@/config/index.js';
import { reportData } from '@/api/report';
import 'swiper/css/swiper.css';
export default {
  name: 'AdSwiperSlide',
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props: {
    // 广告banner位置
    bannerLocation: {
      type: Number,
      default: 1,
    },
    swiperOption: {
      type: Object,
      default: () => {
        return {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoplay: {
            delay: 3000, // 3秒切换一次
            disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay，默认是true
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            bulletActiveClass: 'my-bullet-active',
          },
          on: {
            click(e) {
              if (
                e.target.className.includes('swiper-pagination-bullet') &&
                e.target.localName == 'span'
              )
                return;
              let realIndex = this.realIndex;
              _this.handleLink(_this.bannerList[realIndex]);
            },
          },
        };
      },
    },
  },
  data() {
    return {
      bannerList: [],
      downloadImg: `${CDN_URL}/gameCenter/download.png`, // 点击下载小图标
    };
  },
  computed: {
    hasBannerList() {
      return this.bannerList.length ? true : false;
    },
  },
  created() {
    _this = this;
    this.getBannerList();
  },
  methods: {
    async getBannerList() {
      const r = await getBannerList();
      this.bannerList = [...r.data];
    },
    handleLink(item) {
      reportData({
        type: 2,
        data_type: 2,
      });
      window.open(item.link, '_self');
    },
  },
};
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';
// 轮播图
.swiper {
  width: 361px;
  height: 160px;
  margin: auto;
  border-radius: 7px;
  box-shadow: 0px 5px 6px 0px rgba(60, 10, 10, 0.2);
  overflow: hidden;
  position: relative;
  .swiper-slide {
    list-style: none;
    float: left;
    width: 361px;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100%;
    position: relative;
    .banner-bottom {
      width: 100%;
      height: 45px;
      background-color: rgba(0, 0, 0, 0.3);
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      padding: 0px 10px 8px 10px;
      > img:nth-child(1) {
        width: 37px;
        height: 37px;
        border-radius: 7px;
        margin-right: 7px;
        margin-top: 4px;
      }
      .banner-info {
        width: 230px;
        height: 26px;
        color: #fff;
        font-weight: 400;
        margin-top: 7px;
        .info-title {
          width: 100%;
          line-height: 13px;
          font-size: 13px;
        }
        .info-description {
          @include ellipsis(1);
          width: 100%;
          font-size: 10px;
          line-height: 13px;
          margin-top: 3px;
        }
      }
      > img:nth-child(3) {
        width: 70px;
        height: auto;
        margin-top: 10px;
      }
    }
  }
}
</style>
<style>
.my-bullet-active {
  background-color: #ffd164;
  opacity: 1;
}
</style>
